export enum AuthDestination {
  LOGIN = 'login',
  REGISTER = 'register',
  APPLIST = 'applist',
  APP = 'app',
  RESETPW = 'resetpw',
}
